export default "__VITE_ASSET__Bs06hI8q__"